import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { MalwareInfo } from '../../../../shared/model-typings/malwarereport';

function getMalwareRevision(malwareRevisionId: number) {
  return get<MalwareInfo>(`/api/v2/issues/malware/${malwareRevisionId}`);
}

export const getQueryKey = (malwareRevisionId: number): QueryKey => ['issues', 'malware', malwareRevisionId];

/**
 * Fetch malware information for a specific malware revision ID.
 *
 * @param {number} malwareRevisionId - The ID of the malware revision to fetch.
 */
export default function useGetMalwareInfo(
  malwareRevisionId: number,
) {
  return useQuery({
    queryKey: getQueryKey(malwareRevisionId),
    queryFn: () => getMalwareRevision(malwareRevisionId),
  });
}
